<template>
   <div id="thanks">

      <div class="wrapper stepUp">
          <div class="thanksContainer">
          <div class="cardicon">
            
    <svg width="35" height="26" viewBox="0 0 35 26" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon2'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M32.51.996H6.192A2.334 2.334 0 003.87 3.327v1.555H2.322A2.334 2.334 0 000 7.213v16.32a2.334 2.334 0 002.322 2.332H28.64a2.334 2.334 0 002.322-2.331v-1.555h1.548a2.334 2.334 0 002.322-2.331V3.328A2.334 2.334 0 0032.51.995zm-3.096 22.538a.778.778 0 01-.774.777H2.322a.778.778 0 01-.774-.777v-9.326h27.866v9.326zm0-10.88H1.548v-2.332h27.866v2.331zm0-3.886H1.548V7.213c0-.427.348-.777.774-.777H28.64c.425 0 .774.35.774.777v1.555zm3.87 10.88a.778.778 0 01-.774.777h-1.548V7.213a2.334 2.334 0 00-2.322-2.331H5.418V3.327c0-.427.349-.777.774-.777H32.51c.426 0 .774.35.774.777v16.32zm-11.61 2.331c.464 0 .967-.116 1.354-.35.387.234.851.35 1.354.35 1.51 0 2.71-1.204 2.71-2.72 0-1.515-1.2-2.72-2.71-2.72-.464 0-.967.117-1.354.35-.387-.233-.852-.35-1.355-.35a2.698 2.698 0 00-2.709 2.72c0 1.516 1.2 2.72 2.71 2.72zm0-3.885c.309 0 .58.116.812.35.31.31.774.31 1.084 0 .232-.195.503-.35.812-.35.658 0 1.162.505 1.162 1.165 0 .622-.504 1.166-1.162 1.166-.31 0-.58-.117-.812-.35a.763.763 0 00-.542-.233.762.762 0 00-.542.233c-.232.233-.503.35-.813.35a1.167 1.167 0 01-1.16-1.166c0-.66.502-1.165 1.16-1.165z"/></svg>
   <p class="logo">Нужна<span>Кредитка!</span></p>
   </div>
          <p class="txt">Спасибо за заявку!<br>Оператор свяжется с вами в течение 15 минут.</p>
      </div>
      </div>
      </div>
</template>

<script>
export default {
  name: 'thanks',
}
</script>

<style scoped>
#thanks{background-color: #F5F6FC; height: 140vw;}
.cardicon{display: flex; align-items: center; padding-bottom: 27vw; justify-content: center;}
.logo{font-size: 5vw;font-weight: bold;}
.icon2{fill:#676767;padding-right: 1vw; width:50px;height: 40px;}
span{color: #5F2EEA;}
.thanksContainer{ width: 86%;height: 130vw;margin-right: auto;margin-left: auto;padding-top: 35vw;}
.txt{font-size: 4.6vw; text-align: center}


@media screen and (min-width: 1140px) {
.logo{font-size: 30px;}
.txt{font-size: 30px;}
.cardicon{padding-bottom: 170px;}
.thanksContainer{padding-top: 150px;height: 642px;}
#thanks{ height: 674px;}

}
</style>